import { Box, Container, Heading, Link, Stack } from '@hover/blueprint';
import React, { useState } from 'react';
import {
  ACTIVATE_THE_NEW_CONSTRUCTION_SOLUTION_LINK,
  URLS,
} from '../../constants';
import { DownloadAppModal } from '../common';
import ArrowButton from '../ui/ArrowButton';

const TransformBusiness: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => setIsOpen(!isOpen);
  return (
    <Box w="100%" justifyContent="center" py={1000} bg="brandNavy.500">
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container
        w="100%"
        maxW="1200px"
        px={{ base: 500, tablet: '56px' }}
        centerContent
      >
        <Heading
          as="h2"
          color="neutral.0"
          textAlign="center"
          size={{ base: 500, tablet: 600, desktop: 700 }}
          marginBottom={{ base: 500, desktop: 500 }}
        >
          Start using HOVER for your new construction jobs today
        </Heading>
        <Heading
          as="p"
          isDisplay
          color="neutral.0"
          textAlign="center"
          size={{ base: 300, tablet: 500 }}
          marginBottom={{ base: 700, desktop: 700 }}
          maxW="2xl"
        >
          There is no cost to turn it on. Per job pricing for jobs created with
          blueprints starts at $150.
        </Heading>
        <Box display="flex" gap={100} />
        <Stack
          direction={{ base: 'column', desktop: 'row' }}
          spacing={{ base: 500, desktop: 400 }}
          alignItems="center"
        >
          <ArrowButton
            as={Link}
            href={ACTIVATE_THE_NEW_CONSTRUCTION_SOLUTION_LINK}
            colorScheme="brandNavy"
            variant="inverted"
            w={{ base: '100%', tablet: 'auto' }}
          >
            TURN IT ON
          </ArrowButton>
          <ArrowButton
            as={Link}
            href={URLS.newConstructionSolution.chatWithUs}
            w={{ base: '100%', tablet: 'auto' }}
            variant="minimal"
            colorScheme="neutral"
            // TODO(buttons): remove when we remove padding in Blueprint
            sx={{ div: { pl: 100, pr: 50 } }}
          >
            Chat with us
          </ArrowButton>
        </Stack>
      </Container>
    </Box>
  );
};

export default TransformBusiness;
